import ProSelectInput from "../../../../Components/Inputs/SelectField"
import FormSectionWrapper from "../../../../Components/ProForms/FormSectionWrapper";

const ProjectOwnershipSection = ({
  defaultFormProps,
  formConfig,
  permissions,
  clients,
}) => {
  const fieldPermission = key => permissions.fieldPerObj[formConfig[key].perKey];

  const fields = [
    { key: "projectOwner" },
    { key: "projectDeveloper" },
    { key: "projectEPC" },
  ];

  return (
    permissions.canView && (
      <FormSectionWrapper collapsible title="Project Ownership (Partners)">
        {fields.map(({ key }) => {
          const config = formConfig[key];
          return (
            <ProSelectInput
              key={key}
              {...defaultFormProps}
              {...config}
              options={clients}
              permission={fieldPermission(key)}
            />
          );
        })}
      </FormSectionWrapper>
    )
  );
};

export default ProjectOwnershipSection;
